import {default as enUS} from './enUS.json';
import {default as deDE} from './deDE.json';

export default {
    [deDE.locale]: deDE,
    [enUS.locale]: enUS,
};
